import { PublishScheduleDialogProps } from '../types';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { Button } from '@components/ui/button';
import { PublishScheduleConfirmationConflicts } from './conflicts';
import { PublishScheduleConfirmationNotificationSummary } from './notificationSummary';
import { usePostHog } from '@posthog/react';

export const PublishScheduleConfirmationDialog = ({
  open,
  setOpen,
  onConfirm,
  disabled,
  date,
  conflicts,
  name,
  summaryDetail,
  customTitle,
  crewsWithoutPhoneIds,
  crewsWithPhoneIds = [],
  fieldUserAsCrewIds = [],
  uniqueForemenIds = [],
}: PublishScheduleDialogProps) => {
  const { t } = useTranslation('app');
  const posthog = usePostHog();

  const totalCount = Array.from(
    new Set([...crewsWithPhoneIds, ...fieldUserAsCrewIds, ...uniqueForemenIds]),
  ).length;

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {customTitle
              ? t('publisher.customTitle', { name: name || '', count: totalCount || 0 })
              : t('publisher.date.title', { date, count: totalCount || 0 })}
          </AlertDialogTitle>
          <AlertDialogDescription>{t('publisher.description.first')}</AlertDialogDescription>
          <AlertDialogDescription>{t('publisher.description.second')}</AlertDialogDescription>
        </AlertDialogHeader>
        <PublishScheduleConfirmationNotificationSummary
          crewsWithPhoneIds={crewsWithPhoneIds}
          crewsWithoutPhoneIds={crewsWithoutPhoneIds}
          fieldUserAsCrewIds={fieldUserAsCrewIds}
          uniqueForemenIds={uniqueForemenIds}
        />
        <PublishScheduleConfirmationConflicts
          conflicts={conflicts}
          name={name}
          summaryDetail={summaryDetail}
          date={date}
        />
        <AlertDialogFooter>
          <Button onClick={() => setOpen(false)} variant="secondary" disabled={disabled}>
            {t('actions.cancel')}
          </Button>
          <Button
            onClick={() => {
              posthog?.capture('schedule_published', {
                recipient_count: totalCount,
                has_conflicts: (conflicts?.length ?? 0) > 0,
              });
              onConfirm();
              setOpen(false);
            }}
            disabled={disabled}>
            {t('actions.sendSchedules')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
